import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetInboundSmsRules as GetInboundSmsRulesQuery} from 'nutshell-graphql-types';

import GET_INBOUND_SMS_RULES from '../queries/get-inbound-sms-rules.graphql';

export const useGetInboundSmsRules = () => {
    const {data, error, loading, refetch} = useQuery<GetInboundSmsRulesQuery, Record<any, any>>(
        GET_INBOUND_SMS_RULES,
        {}
    );

    const {inboundSmsRules} = makeDataDangerous(data);

    return {
        inboundSmsRules,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
